export enum DocumentDetailsStandardAction {
  UPLOAD_FILE = 'upload_file',
  DOWNLOAD_FILE = 'download_file',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT = 'set_document_required_is_not_sent',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED = 'remove_required_file_type_from_documentation_required',
}
